import { Trans } from 'react-i18next';
import { ProposalInfluencer } from '@anytag/graphql';
import { useQueryHelper } from '@anytag/shared-hooks';
import { Icon, BaseModal, BaseModalProps } from '@anytag/shared-atoms';

export interface WarningCouponModalProps extends BaseModalProps {
  couponCodes: number;
  engagementId: number;
  influencers: readonly ProposalInfluencer[];
}

export const WarningCouponModal = ({
  footer,
  onClose,
  influencers,
  couponCodes,
  engagementId,
  ...restProps
}: WarningCouponModalProps) => {
  const { t, navigate, pathname } = useQueryHelper();

  const numberOfSelectedInfluencers = influencers.filter((infl) => !infl.isDenied).length;

  const handleNavigateToCampaignDetails = () => {
    navigate({
      to: '/engagement/$id',
      params: { id: engagementId.toString() },
      search: { state: { redirectUrlAfterUpdateEngagement: pathname } }
    });
    onClose?.();
  };

  return (
    <BaseModal
      onClose={onClose}
      title={
        <>
          <Icon icon="warning" variant="yellow" size="20px" className="mr-2.5" />
          {t('warningCouponModalTitle')}
        </>
      }
      description={
        <>
          <p>
            <Trans
              i18nKey="warningCouponModalDescription"
              values={{ amount: numberOfSelectedInfluencers - couponCodes }}
              components={{ b: <b /> }}
            />
          </p>
          <p>
            {t('Suggested influencers')}: <b>{numberOfSelectedInfluencers}</b>
            <br />
            {t('Uploaded referral codes')}: <b>{couponCodes}</b>
          </p>
        </>
      }
      footer={{
        ...footer,
        cancelButton: { title: t('Button.Cancel'), onClick: onClose, ...footer?.cancelButton },
        submitButton: {
          title: t('Button.Edit campaign detail'),
          onClick: handleNavigateToCampaignDetails,
          ...footer?.submitButton
        }
      }}
      {...restProps}
    />
  );
};
